import { observer } from 'mobx-react-lite';
import React from 'react';

import { useActiveBrandConfig } from '@/brand';
import { useTheme } from '@/ui/theme';

export const BrandLogo = observer(() => {
  const {
    logoUrl,
    componentProperties: { header },
  } = useTheme();
  const { name } = useActiveBrandConfig();
  return (
    <img
      css={{
        maxWidth: '100%',
        maxHeight: '100%',
        width: 'auto',
        height: 'auto',
        objectFit: 'contain',
        padding: header?.logo?.padding,
        paddingBlock: header?.logo?.paddingBlock,
        paddingInline: header?.logo?.paddingInline,
      }}
      src={logoUrl}
      alt={name}
    />
  );
});

export default BrandLogo;
